(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/form-context.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/form-context.trinidad.js');
"use strict";

(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (form_context)
  });
  ; 
  const external_React_namespaceObject = window["React"];
  var external_React_default = __webpack_require__.n(external_React_namespaceObject);
  ; 

  const FormContext = external_React_default().createContext({
    form: {},
    handleBlur: () => {},
    handleChange: () => {},
    handleFocus: () => {},
    register: () => {}
  });
  const form_context = FormContext;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).FormContext = __webpack_exports__["default"];
})();

 })(window);